export const STEPS = {
    ADD_CAR: 'addCar',
    AUTH: 'auth',
    NOTIFY: 'notify',
    SELECT_PAY_METHOD: 'select-pay-method',
    SUB_MANAGEMENT: 'sub_management',
    VERIFY: 'verify',
} as const

export type Steps = (typeof STEPS)[keyof typeof STEPS]
